import { createSlice } from '@reduxjs/toolkit'
import { type IListings, type ILeads, type IActivies } from '../api/types'

interface IInitialState {
  activeListings: IListings | null
  leads: ILeads | null
  activities: IActivies | null
}

const initialState: IInitialState = {
  activeListings: null,
  leads: null,
  activities: null
}

export const ihfSlice = createSlice({
  initialState,
  name: 'ihf',
  reducers: {
    getActiveListings: (state, action) => {
      const listings = action.payload
      state.activeListings = listings
    },
    getLeads: (state, action) => {
      const leads = action.payload
      state.leads = leads
    },
    getActivities: (state, action) => {
      const activities = action.payload
      state.activities = activities
    }
  }
})

export default ihfSlice.reducer

export const { getActiveListings, getLeads, getActivities } = ihfSlice.actions
